import moment from 'moment';
import 'moment/locale/ko';
import * as XLSX from 'xlsx';
import { copyLessonsToNextWeek } from '../api/lesson';
import { getUsersList } from '../api/member-management';

moment.locale('ko');

// HTML 약관(CKEditor) 내용을 미리보기/입력칸 표시용 일반 텍스트로 변환한다.
export const stripHtml = html =>
  (html || '')
    .replace(/<\/(p|div|li|h[1-6])>|<br\s*\/?>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

export function getAge(dob) {
  const today = new Date();
  const getBirthYear = parseInt(dob.substring(0, 4));
  const getBirthMonth = parseInt(dob.substring(4, 6));
  const getBirthDay = parseInt(dob.substring(6));
  var calAge = today.getFullYear() - getBirthYear;
  const calAgeMonth = today.getMonth() + 1 - getBirthMonth;
  const calAgeDay = today.getDate() - getBirthDay;
  if (calAgeMonth < 0 || (calAgeMonth === 0 && calAgeDay < 0)) {
    calAge = calAge - 1;
  }
  return calAge;
}

export const formatDate = (date, format) => {
  const formattedDate = moment(date, 'YYYY-MM-DD HH:mm:ss').format(format);

  return formattedDate;
};

export const dateConverter = selected => {
  if (selected && !isNaN(selected) && selected.$d) {
    const date = selected.$d.toLocaleDateString('en-US').split('/');
    return `${date[2]}-${date[0].length === 1 ? '0' + date[0] : date[0]}-${
      date[1].length === 1 ? '0' + date[1] : date[1]
    }`;
  }
  return selected;
};

function buildFormData(formData, data, parentKey) {
  if (data && typeof data === 'object' && !data.lastModified) {
    Object.keys(data).forEach(key => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    const value = data == null ? '' : data;
    formData.append(parentKey, value);
  }
}

export function jsonToFormData(data) {
  const formData = new FormData();

  buildFormData(formData, data);

  return formData;
}

function converterJTFD(formData, data, parentKey) {
  //for fix backend issue
  if (data && typeof data === 'object' && !data.lastModified) {
    Object.keys(data).forEach(key => {
      const a = `${parentKey}[${key}]`.split('.')[0];
      const b = `${parentKey}[${key}]`.split('.')[1]?.replace('[', '').replace(']', '');
      converterJTFD(formData, data[key], parentKey ? (b ? `${a}.${b}` : `${parentKey}[${key}].`) : key);
    });
  } else {
    const value = data == null ? '' : data;
    formData.append(parentKey, value);
  }
}

export const removeEmptyValues = data => {
  for (var propName in data) {
    if (data[propName] === null || data[propName] === undefined || data[propName] === '') {
      delete data[propName];
    }
  }
  return data;
};

export function converterJsonToFormData(data) {
  const formData = new FormData();

  converterJTFD(formData, data);

  return formData;
}

const tasks = {};

export function debounce(callBack, nameTask, duration = 1000) {
  // get task
  let task = tasks[nameTask];

  // remove timeout if it has
  task && clearTimeout(task);

  // set new task or update
  tasks[nameTask] = setTimeout(callBack, duration);
}

export function calculateDays(startDate, endDate, day) {
  var start = moment(startDate).subtract(1, 'days'),
    end = moment(endDate).subtract(-1, 'days');
  var result = [];

  var current = start.clone();
  while (current.day(7 + day).isBefore(end)) {
    result.push(current.clone());
  }
  return result.map(m => m.format('YYYY-MM-DD'));
}

export const getDisabledValues = (weeks, activeIndex) => {
  return weeks
    .filter((_, index) => index !== activeIndex)
    .reduce((pv, cv) => {
      pv = [...pv, ...cv];
      return pv;
    }, []);
};

export const getAllLessonEvents = data => {
  if (data.length) {
    const transformedEvents = data.map(event => ({
      id: event.courseClassTimeId,
      title: `${event.trainerName} | ${event.memberName || event.maxMemberCount}`,
      start: `${event.classDate}T${event.startTime}`,
      end: `${event.classDate}T${event.endTime}`,
      extendedProps: {
        eventData: event,
        trainerName: event.trainerName,
        branchExerciseRoomName: event.branchExerciseRoomName,
        memberName: event.memberName,
      },
    }));
    return transformedEvents;

    // return data.reduce((allEvents, lesson) => {
    //   return allEvents.concat(
    //     lesson.weeks.flatMap(cv =>
    //       cv.calDateList.map(event => ({
    //         ...event,
    //         title: lesson.className ? lesson.className : '',
    //         week: cv.week,
    //         extendedProps: {
    //           ...lesson,
    //           weekId: cv.id,
    //           eventData: { ...cv, ...event },
    //         },
    //       })),
    //     ),
    //   );
    // }, []);
  }
};

export const dateFormatter = date => {
  return new Date(date).toISOString().replace(/T.*$/, '');
};

export const getCalendarWeekRange = calendar => {
  if (calendar) {
    const activeRange = calendar.getApi().currentDataManager.state.dateProfile.activeRange;
    const start = dateFormatter(activeRange.start);
    const end = getPreviousDay(new Date(activeRange.end));
    return { start: start, end: end };
  }
};

export function getPreviousDay(date = new Date()) {
  const previous = new Date(date.getTime());
  previous.setDate(date.getDate() - 1);

  return dateFormatter(previous);
}

export function lessonSwitcher(type) {
  switch (type) {
    case 0:
      return '1-on-1';
    case 1:
      return 'Group';
    case 2:
      return 'Online';
    default:
      return '';
  }
}

export function filterTrainers(list1 = [], list2 = []) {
  const newTrainers = list1.filter(item1 => !list2.some(item2 => item2.id === item1.trainerId));
  const transformArray = newTrainers.map(item => ({
    id: item.trainerId,
    name: item.trainerName,
  }));
  return transformArray;
}

export function filterTickets(list1 = [], list2 = []) {
  const newTickets = list1.filter(item1 => !list2.some(item2 => item2.id === item1.courseTicketId));

  const transformArray = newTickets.map(item => ({
    id: item.courseTicketId,
    name:
      item.courseTicketName + ' ' + (item.usageCount ? item.usageCount + '회' : '') + ' ' + item?.usagePeriodDisplay,
  }));
  return transformArray;
}

export function trainerIdsList(trainers) {
  const trainerIdsList = trainers.map(tr => ({ id: tr.id }));

  return trainerIdsList;
}

export function addMinutesToTime(timeString) {
  if (!timeString) {
    return timeString;
  }
  const timeParts = timeString.split(':');
  const hours = parseInt(timeParts[0]);
  const minutes = parseInt(timeParts[1]);
  const seconds = parseInt(timeParts[2] || 0);

  const newMinutes = minutes + 50;

  const hoursOverflow = Math.floor(newMinutes / 60);

  const adjustedMinutes = newMinutes % 60;

  const adjustedHours = (hours + hoursOverflow) % 24;

  const newTimeString = `${String(adjustedHours).padStart(2, '0')}:${String(adjustedMinutes).padStart(2, '0')}:${String(
    seconds,
  ).padStart(2, '0')}`;

  return newTimeString;
}

export const exportToExcel = data => {
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Table Data');
  XLSX.writeFile(wb, 'table_data.xlsx');
};

export const exportUsersToExcel = async (data, token, setLoading) => {
  setLoading(true);
  if (!data.content.some(user => user.isChecked !== true)) {
    const users = await getUsersList(token, { offset: 1, limit: data.totalElements });
    exportToExcel(users.content);
  } else {
    const users = data.content.filter(user => user.isChecked);
    exportToExcel(users);
  }
  setLoading(false);
};

export const removeDublicates = list => {
  const uniqueObjects = [];
  const seenIds = new Set();

  for (const obj of list) {
    const id = obj['id'];

    if (!seenIds.has(id)) {
      seenIds.add(id);
      uniqueObjects.push(obj);
    }
  }

  return uniqueObjects;
};

export const getInstructors = (ticketId, tickets) => {
  if (ticketId) {
    return tickets.find(t => t.id === ticketId)?.traineres;
  }
  return tickets.reduce((pv, sv) => {
    if (sv.traineres) {
      pv = [...pv, ...sv.traineres];
    }
    return removeDublicates(pv);
  }, []);
};

export function imageValidation(file) {
  return new Promise((resolve, reject) => {
    // Image type tekshirish JPEG, JPG, PNG
    if (!/^image\/(jpeg|jpg|png)$/.test(file.type)) {
      reject('Please upload a valid PNG or JPEG image');
      return;
    }

    if (file.size > 8 * 1024 * 1024) {
      // Image size tekshirish 8MB
      reject('The file size exceeds the maximum allowed size of 8MB');
      return;
    }

    resolve(file);
  });
}

export const toTop = () => {
  return window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
};

export const formatPhoneNumber = phoneNumber => {
  if (!phoneNumber) {
    return phoneNumber;
  }

  let numbers = phoneNumber.replace(/\D/g, ''); // Use let here instead of const

  const chunks = [];
  while (numbers.length > 4) {
    chunks.unshift(numbers.slice(-4)); // Get the last 4 digits
    numbers = numbers.slice(0, numbers.length - 4); // Remove the last 4 digits
  }

  if (numbers.length > 0) {
    chunks.unshift(numbers); // Add the final chunk of less than 4 digits
  }

  return chunks.join('-');
};

// 사업자등록번호 (XXX-XX-XXXXX)
export const formatBRN = input => {
  let digits = String(input).replace(/\D/g, '');
  if (digits.length > 10) digits = digits.slice(0, 10);

  if (digits.length > 5) {
    return digits.replace(/(\d{3})(\d{2})(\d{0,5})/, '$1-$2-$3');
  } else if (digits.length > 3) {
    return digits.replace(/(\d{3})(\d{0,2})/, '$1-$2');
  } else {
    return digits;
  }
};

// 휴대폰 번호 (010-xxxx-xxxx / 010-xxx-xxxx)
export const formatPhone = input => {
  let digits = String(input).replace(/\D/g, '');
  if (digits.length > 11) digits = digits.slice(0, 11);

  if (digits.length > 7) {
    return digits.replace(/(\d{3})(\d{4})(\d{0,4})/, '$1-$2-$3');
  } else if (digits.length > 3) {
    return digits.replace(/(\d{3})(\d{0,4})/, '$1-$2');
  } else {
    return digits;
  }
};

// 대표 전화번호 (휴대폰/서울(02)/지역 모두 자동 포맷)
// 예) 010-1234-5678, 02-123-4567, 02-1234-5678, 031-123-4567, 031-1234-5678
export const formatLandlinePhone = input => {
  if (!input) return '';
  let digits = String(input).replace(/\D/g, '');

  // 0507 안심번호(평생번호) — 12자리, 4-4-4
  if (digits.startsWith('0507')) {
    if (digits.length > 12) digits = digits.slice(0, 12);
    if (digits.length <= 4) return digits;
    if (digits.length <= 8) return digits.replace(/(\d{4})(\d{0,4})/, '$1-$2');
    return digits.replace(/(\d{4})(\d{4})(\d{0,4})/, '$1-$2-$3');
  }

  if (digits.length > 11) digits = digits.slice(0, 11);

  // 서울 지역번호(02) — 국번은 입력 길이에 따라 3자리 또는 4자리
  if (digits.startsWith('02')) {
    if (digits.length <= 2) return digits;
    if (digits.length <= 5) {
      // 02-1 ~ 02-123 (입력 중)
      return digits.replace(/(\d{2})(\d{0,3})/, '$1-$2');
    }
    if (digits.length <= 9) {
      // 02-123-4567 (구 형식, 2-3-4)
      return digits.replace(/(\d{2})(\d{3})(\d{0,4})/, '$1-$2-$3');
    }
    // 02-1234-5678 (신 형식, 2-4-4)
    return digits.replace(/(\d{2})(\d{4})(\d{0,4})/, '$1-$2-$3');
  }

  // 휴대폰(010/011/016~019) 또는 3자리 지역번호(031~064)
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) {
    // 031-1 ~ 031-123 (입력 중)
    return digits.replace(/(\d{3})(\d{0,3})/, '$1-$2');
  }
  if (digits.length <= 10) {
    // 031-123-4567 (3-3-4)
    return digits.replace(/(\d{3})(\d{3})(\d{0,4})/, '$1-$2-$3');
  }
  // 010-1234-5678 / 031-1234-5678 (3-4-4)
  return digits.replace(/(\d{3})(\d{4})(\d{0,4})/, '$1-$2-$3');
};

export function formatterCurrency(value) {
  if (value === '' || value === null || value === undefined) return '';

  // 쉼표 제거 후 숫자로 변환 (소수점 포함)
  const numericValue = Number(String(value).replace(/,/g, ''));

  if (isNaN(numericValue)) return '';

  // 소수점 버리고 정수로 천 단위 쉼표 포맷팅
  return Math.floor(numericValue).toLocaleString('ko-KR');
}

export const changeDateAroundMonths = monthIndex => {
  const currentDate = new Date();
  currentDate.setMonth(currentDate.getMonth() + monthIndex);
  let startDate = new Date(currentDate.setDate(1)).toISOString().split('T')[0];
  let endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1).toISOString().split('T')[0];

  return { startDate, endDate };
};

export const paymentType = type => {
  switch (type) {
    case 'CARD':
      return 'Credit Card';
    case 1:
      return 'Mobile';
    case 2:
      return 'Kakao Pay';
    case 3:
      return 'Naver Pay';
    default:
      return '';
  }
};

export const sellStatus = (status, t = () => {}) => {
  switch (status) {
    case 'APPROVED':
      return (
        <span className="t-status" style={{ color: '#0F7F85', borderColor: '#0F7F85' }}>
          {t('On Sale')}
        </span>
      );
    case 'EXPIRED':
      return (
        <span className="t-status" style={{ color: '#0F7F85', borderColor: '#0F7F85' }}>
          {t('Completed')}
        </span>
      );
    case 'APPROVAL_PENDING':
      return (
        <span className="t-status" style={{ color: '#5A5A5A', borderColor: '#5A5A5A' }}>
          {t('Pending Approval')}
        </span>
      );
    case 'REFUSED':
      return (
        <span className="t-status" style={{ color: '#EF0C23', borderColor: '#EF0C23' }}>
          {t('Approval Rejected')}
        </span>
      );
    default:
      return '';
  }
};

export const copyToNextWeek = async (multiList, token, setOpens, opens, toast) => {
  const copyDaysList = multiList.map(item => {
    const currentDate = new Date(item.start);
    const sevenDaysLater = new Date(currentDate.setDate(currentDate.getDate() + 7));

    return {
      lessonId: item.extendedProps.id,
      day: sevenDaysLater.toISOString().slice(0, 10),
      week: item.week,
      ticketId: item.ticketId,
      timeStart: item.start.split('T')[1],
      timeEnd: item.end.split('T')[1],
      pointId: item.extendedProps.pointId,
      roomId: item.extendedProps.roomId,
    };
  });

  try {
    const { data } = await copyLessonsToNextWeek(copyDaysList, token);
    if (data.length) {
      setOpens({ ...opens, busyDates: data });
      toast.success('복사 완료');
    } else {
      const btn = document.getElementsByClassName('fc-next-button')[0];
      btn.click();
    }
  } catch (error) {
    toast.error(errorMessages(error));
    return false;
  }
};

export const getUserPoints = (user, list) => {
  if (!user.userRole === 'ROLE_SUPERADMIN') {
    return list.filter(p => p.id === user.userPoint.pointId);
  } else return list;
};

export const getPointTrainers = (user, list) => {
  if (list.length) {
    return list.data.pointsList.find(p => p.id === user.userPoint.pointId).trainerList;
  } else return [];
};

// 401 alert가 여러 API 동시 실패 시 중복으로 뜨지 않도록 가드
let sessionExpiredHandled = false;

export const errorMessages = error => {
  if (typeof error === 'string') {
    return error;
  }
  if (error?.response?.status === 401) {
    if (error?.response?.data?.errorCode === 'BAD_CREDENTIALS' || error?.response?.data?.errorCode === 'AUTH_BAD_CREDENTIALS') {
      return error?.response?.data?.message || '아이디 또는 비밀번호가 올바르지 않습니다.';
    }
    if (!sessionExpiredHandled) {
      sessionExpiredHandled = true;
      window.alert('로그인 세션이 만료되었습니다.\n다시 로그인 해주세요.');
      localStorage.removeItem('pila-user');
      localStorage.removeItem('user-menu');
      window.location.replace('/login');
    }
    return '';
  }
  if (error?.response?.status === 403) {
    return '접근 권한이 없습니다.';
  }
  if (error?.response?.status === 404) {
    return error.response.data.message;
  }
  if (error?.response?.status === 400) {
    return error.response.data.message;
  }
  if (error?.response?.status === 406) {
    return error.response.data.message;
  }
  if (error?.response?.status === 409) {
    return error.response.data.message;
  }
  if (error?.response?.status === 500) {
    return error.response.data.message;
  }
  return error.message;
};

export const getDateRange = days => {
  const today = new Date();
  const date = new Date().setDate(new Date().getDate() + days);
  return { from: dateFormatter(today), to: dateFormatter(date) };
};

export const isKoreanOnly = (text, allowSpaces = true) => {
  if (!text || typeof text !== 'string') {
    return false;
  }

  // 한글 유니코드 범위: ㄱ-ㅎ (자음), ㅏ-ㅣ (모음), 가-힣 (완성된 한글)
  const koreanRegex = allowSpaces
    ? /^[ㄱ-ㅎㅏ-ㅣ가-힣\s]+$/ // 공백 포함
    : /^[ㄱ-ㅎㅏ-ㅣ가-힣]+$/; // 공백 제외

  return koreanRegex.test(text);
};

// 날짜 비교 유효성 검증 함수
export const validateDateRange = (startDate, endDate) => {
  // 두 날짜가 모두 빈값이 아닐 때만 검증
  if (startDate && endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    // 시작일이 종료일보다 늦은 경우
    if (start > end) {
      return false;
    }
  }
  return true;
};

/**
 * 텍스트 길이 계산 (한글은 2, 영문/숫자는 1)
 */
const getTextWidth = text => {
  if (!text) return 0;
  const str = String(text);
  return str.split('').reduce((acc, char) => {
    if (/[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(char)) return acc + 2;
    if (/[A-Z]/.test(char)) return acc + 1.3;
    return acc + 1;
  }, 0);
};

/**
 * ExcelJS를 사용한 스타일이 적용된 엑셀 파일 다운로드
 * - 맑은 고딕 폰트
 * - 헤더 배경색, 굵은 글씨
 * - 모든 셀 테두리
 * - 열 너비 자동 조정 (텍스트 길이 기반)
 * - 헤더 행 고정
 */
export const exportStyledExcel = async (data, options = {}) => {
  const ExcelJS = await import('exceljs');
  const {
    filename = 'export',
    sheetName = 'Sheet1',
    // 'default' = 진한 머리글 + 줄무늬(기존 화면들). 'form' = 종이 양식처럼 흰 바탕에 얇은 검정 선.
    variant = 'default',
    headerColor = variant === 'form' ? 'F2F2F2' : '0F7F85',
    columnAlignments = {},
    // 값이 이미지 URL 인 컬럼 이름들. 해당 셀은 글자 대신 그림으로 박힌다.
    // 지정하지 않으면 기존과 동일하게 전부 텍스트로 쓴다.
    imageColumns = [],
    imageRowHeight = 48,
    imageColumnWidth = 14,
    // 표 위에 얹을 정보 블록. 한 줄에 여러 항목을 넣을 수 있게 [[{label, value}, ...], ...] 형태다.
    // 마지막 값 칸은 표 오른쪽 끝까지 병합된다. 블록이 있으면 표 머리글 앞에 빈 줄 하나를 둔다.
    infoRows = [],
    // 컬럼 폭 직접 지정. { 헤더명: 숫자 }. 지정하지 않은 컬럼은 글자 길이로 자동 계산한다.
    columnWidths = {},
    // 행 글자색 지정. rowData => 'C62828' 같은 RGB 문자열(없으면 null). 배경은 건드리지 않는다.
    rowFontColor = null,
    // 숫자 서식. { 헤더명: '#,##0"원"' }. 값을 숫자로 넘기면 엑셀에서 합계·정렬이 되면서 보기엔 서식대로 나온다.
    numFmts = {},
    // 표 맨 아래 합계 행. { 헤더명: 값 } 형태이며 비운 컬럼은 빈 칸. 굵은 글씨·연회색 바탕.
    footerRow = null,
  } = options;

  const isForm = variant === 'form';
  const headerFontColor = isForm ? 'FF333333' : 'FFFFFFFF';
  const bodyBorderColor = isForm ? 'FF333333' : 'FFE0E0E0';

  if (!data || data.length === 0) {
    console.warn('No data to export');
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(sheetName);

  // 헤더 추출
  const headers = Object.keys(data[0]);

  // 각 컬럼별 최대 너비 계산
  const columnMaxWidths = {};
  headers.forEach(header => {
    // 헤더 길이
    columnMaxWidths[header] = getTextWidth(header) + 4;
  });

  // 데이터에서 최대 너비 계산. 이미지 컬럼은 값이 URL 이라 글자 길이를 재면 안 된다.
  data.forEach(row => {
    headers.forEach(header => {
      if (imageColumns.includes(header)) return;
      const cellWidth = getTextWidth(row[header]) + 2;
      if (cellWidth > columnMaxWidths[header]) {
        columnMaxWidths[header] = cellWidth;
      }
    });
  });

  const widthOf = header => {
    if (columnWidths[header]) return columnWidths[header];
    if (imageColumns.includes(header)) return imageColumnWidth;
    return Math.max(10, Math.min(columnMaxWidths[header], 60));
  };

  // 컬럼 설정. header 를 넘기지 않고 아래에서 직접 행을 쌓는다
  // (정보 블록이 있으면 표 머리글이 1행이 아니기 때문)
  const resolvedWidths = headers.map(widthOf);
  worksheet.columns = headers.map((header, i) => ({ key: header, width: resolvedWidths[i] }));

  // 정보 블록 칸이 몇 개 컬럼을 차지해야 글자가 안 잘리는지 계산한다.
  // 표 컬럼 폭은 데이터 기준이라 '전화번호' 같은 라벨이 좁은 컬럼(예: 폭 7)에 걸리면 잘린다.
  const spanToFit = (text, startIndex) => {
    const needed = getTextWidth(text) + 2;
    let span = 0;
    let accumulated = 0;
    while (startIndex + span < headers.length && accumulated < needed) {
      accumulated += resolvedWidths[startIndex + span];
      span += 1;
    }
    return Math.max(span, 1);
  };

  // 표 위 정보 블록 — 한 줄에 (라벨, 값) 쌍을 나란히 놓고 마지막 값만 끝까지 병합한다.
  const infoBorder = {
    top: { style: 'thin', color: { argb: 'FF333333' } },
    left: { style: 'thin', color: { argb: 'FF333333' } },
    bottom: { style: 'thin', color: { argb: 'FF333333' } },
    right: { style: 'thin', color: { argb: 'FF333333' } },
  };
  infoRows.forEach(pairs => {
    const row = worksheet.addRow([]);
    row.height = 24;

    // 칸을 왼쪽부터 채워 나간다. 각 칸은 글자가 들어갈 만큼 컬럼을 합쳐 쓴다.
    let col = 1;
    const putCell = (value, span, isLabel) => {
      const cell = row.getCell(col);
      cell.value = value;
      cell.font = { name: '맑은 고딕', size: 11, bold: isLabel };
      cell.alignment = { horizontal: isLabel ? 'center' : 'left', vertical: 'middle' };
      if (isLabel) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2F2F2' } };
      }
      cell.border = infoBorder;
      if (span > 1) {
        worksheet.mergeCells(row.number, col, row.number, col + span - 1);
      }
      col += span;
    };

    pairs.forEach((pair, pairIndex) => {
      if (col > headers.length) return;
      putCell(pair.label, Math.min(spanToFit(pair.label, col - 1), headers.length - col + 1), true);

      if (col > headers.length) return;
      const isLast = pairIndex === pairs.length - 1;
      // 마지막 값 칸은 표 오른쪽 끝까지 늘린다.
      const valueSpan = isLast
        ? headers.length - col + 1
        : Math.min(spanToFit(pair.value, col - 1), headers.length - col + 1);
      putCell(pair.value, valueSpan, false);
    });
  });
  if (infoRows.length > 0) {
    worksheet.addRow([]).height = 8;
  }

  // 표 머리글. 정보 블록 다음 줄부터 시작한다.
  const headerRow = worksheet.addRow(headers);
  headerRow.height = 28;
  headerRow.eachCell((cell, colNumber) => {
    cell.font = {
      name: '맑은 고딕',
      size: 11,
      bold: true,
      color: { argb: headerFontColor },
    };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: `FF${headerColor}` },
    };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.border = {
      top: { style: 'thin', color: { argb: 'FF333333' } },
      left: { style: 'thin', color: { argb: 'FF333333' } },
      bottom: { style: 'thin', color: { argb: 'FF333333' } },
      right: { style: 'thin', color: { argb: 'FF333333' } },
    };
  });

  // 데이터 행 추가
  data.forEach((rowData, rowIndex) => {
    const rowValues = {};
    headers.forEach(header => {
      let value = rowData[header];
      // null/undefined/NaN 처리
      if (value === null || value === undefined || (typeof value === 'number' && isNaN(value))) {
        value = '';
      }
      // 이미지 컬럼은 셀 값을 비우고 아래에서 그림으로 넣는다.
      rowValues[header] = imageColumns.includes(header) ? '' : value;
    });

    const dataRow = worksheet.addRow(rowValues);
    dataRow.height = imageColumns.length > 0 ? imageRowHeight : 24;

    // 짝수/홀수 행 배경색 다르게 (가독성 향상)
    const isEvenRow = rowIndex % 2 === 0;

    // 상태에 따라 글자색만 바꾼다(배경은 줄무늬 그대로).
    const fontColor = rowFontColor ? rowFontColor(rowData) : null;

    dataRow.eachCell((cell, colNumber) => {
      const header = headers[colNumber - 1];
      const align = columnAlignments[header] || 'center';

      cell.font = {
        name: '맑은 고딕',
        size: 10,
        color: fontColor ? { argb: `FF${fontColor}` } : undefined,
      };
      cell.alignment = { horizontal: align, vertical: 'middle', wrapText: false };
      if (numFmts[header]) cell.numFmt = numFmts[header];
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: isForm || !isEvenRow ? 'FFFFFFFF' : 'FFF9F9F9' },
      };
      cell.border = {
        top: { style: 'thin', color: { argb: bodyBorderColor } },
        left: { style: 'thin', color: { argb: bodyBorderColor } },
        bottom: { style: 'thin', color: { argb: bodyBorderColor } },
        right: { style: 'thin', color: { argb: bodyBorderColor } },
      };
    });
  });

  if (footerRow) {
    const totalRow = worksheet.addRow(headers.map(header => footerRow[header] ?? ''));
    totalRow.height = 26;
    headers.forEach((header, i) => {
      const cell = totalRow.getCell(i + 1);
      cell.font = { name: '맑은 고딕', size: 10, bold: true };
      cell.alignment = { horizontal: columnAlignments[header] || 'center', vertical: 'middle' };
      if (numFmts[header]) cell.numFmt = numFmts[header];
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2F2F2' } };
      cell.border = {
        top: { style: 'thin', color: { argb: 'FF333333' } },
        left: { style: 'thin', color: { argb: 'FF333333' } },
        bottom: { style: 'thin', color: { argb: 'FF333333' } },
        right: { style: 'thin', color: { argb: 'FF333333' } },
      };
    });
  }

  // 이미지 컬럼 삽입. URL 을 실제로 받아와야 해서 행 수만큼 네트워크 요청이 나간다.
  // 받아오지 못한 칸은 빈 칸으로 두고 다운로드 자체는 계속 진행한다.
  if (imageColumns.length > 0) {
    const targets = [];
    data.forEach((rowData, rowIndex) => {
      imageColumns.forEach(header => {
        const url = rowData[header];
        if (url) targets.push({ url, rowIndex, colIndex: headers.indexOf(header) });
      });
    });

    const loaded = await Promise.all(
      targets.map(async target => {
        try {
          // cache: 'reload' 필수 — 화면의 <img> 가 먼저 CORS 없는(opaque) 캐시 항목을 만들어 두면
          // 같은 URL 의 fetch 가 그 캐시를 재사용하다 CORS 로 막힌다. 항상 새로 받아온다.
          const response = await fetch(target.url, { mode: 'cors', cache: 'reload' });
          if (!response.ok) return null;
          const buffer = await response.arrayBuffer();
          return { ...target, buffer };
        } catch (error) {
          console.warn('엑셀 이미지 로드 실패', target.url, error);
          return null;
        }
      })
    );

    loaded.filter(Boolean).forEach(({ buffer, rowIndex, colIndex }) => {
      const imageId = workbook.addImage({ buffer, extension: 'png' });
      // tl 은 0-based 셀 좌표. 머리글 행 번호(1-based)가 곧 첫 데이터 행의 0-based 좌표다.
      worksheet.addImage(imageId, {
        tl: { col: colIndex + 0.1, row: headerRow.number + rowIndex + 0.1 },
        ext: { width: 84, height: imageRowHeight - 8 },
      });
    });
  }

  // 표 머리글까지 고정
  worksheet.views = [
    { state: 'frozen', xSplit: 0, ySplit: headerRow.number, topLeftCell: `A${headerRow.number + 1}` },
  ];

  // 파일명에 날짜 추가
  const today = moment().format('YYYYMMDD');
  const fullFilename = `${filename}_${today}.xlsx`;

  // 파일 다운로드
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fullFilename;
  link.click();
  window.URL.revokeObjectURL(url);
};

/**
 * 회원 목록 엑셀 다운로드 (스타일 적용)
 */
/**
 * 회원목록 엑셀. 화면 컬럼 설정(표시·순서)을 그대로 따른다.
 * @param members 회원 배열
 * @param columns 화면에 보이는 컬럼 정의 [{ label, excel(member, ctx), excelAlign }] — memberListColumns.jsx
 * @param ctx     컬럼 excel() 에 넘길 컨텍스트 { t, currentBranchId, badgeLabel }
 * 지점명은 화면 컬럼이 아니지만 본사 조회 때 필요해 항상 첫 열에 둔다.
 */
export const exportMembersToStyledExcel = async (members, columns, ctx, filename = '회원목록') => {
  const headers = columns.map(column => ctx.t(column.label));
  const filteredData = members.map(member => {
    const row = { 지점명: member.branchName || '' };
    columns.forEach((column, i) => {
      row[headers[i]] = column.excel(member, ctx);
    });
    return row;
  });

  const columnAlignments = { 지점명: 'left' };
  columns.forEach((column, i) => {
    columnAlignments[headers[i]] = column.excelAlign || 'center';
  });

  await exportStyledExcel(filteredData, {
    filename,
    sheetName: '회원목록',
    headerColor: '0F7F85',
    columnAlignments,
  });
};

// ============================================
// 한글 초성 검색
// ============================================
const CHOSUNG = [
  'ㄱ','ㄲ','ㄴ','ㄷ','ㄸ','ㄹ','ㅁ','ㅂ','ㅃ','ㅅ',
  'ㅆ','ㅇ','ㅈ','ㅉ','ㅊ','ㅋ','ㅌ','ㅍ','ㅎ',
];

export const getChosung = str =>
  [...str]
    .map(ch => {
      const code = ch.charCodeAt(0) - 0xac00;
      return code >= 0 && code <= 11171 ? CHOSUNG[Math.floor(code / 588)] : ch;
    })
    .join('');

const isAllChosung = str => [...str].every(ch => CHOSUNG.includes(ch));

/**
 * 한글 초성+일반 텍스트 통합 검색
 * - keyword가 순수 자음이면 초성 매칭
 * - 그 외엔 일반 포함(includes) 매칭
 */
export const matchKorean = (text, keyword) => {
  if (!keyword) return true;
  if (text.includes(keyword)) return true;
  if (isAllChosung(keyword)) {
    return getChosung(text).includes(keyword);
  }
  return false;
};
